import Reveal from "../landing/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

export default function MarcoNormativo() {
  const { t } = useLanguage();

  return (
    <section id="marco" className="bg-cream py-20 md:py-28" data-testid="marco-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <p className="kicker" data-testid="marco-kicker">{t.marco.kicker}</p>
          <h2 className="mt-5 max-w-4xl font-display text-3xl font-bold leading-tight text-forest-800 md:text-4xl lg:text-5xl">
            {t.marco.title}
          </h2>
          <div className="mt-6 h-px w-24 bg-forest-800" aria-hidden="true" />
        </Reveal>

        <div className="mt-12 grid gap-12 lg:grid-cols-5">
          <Reveal className="lg:col-span-2">
            <h3 className="font-body text-[11px] font-bold uppercase tracking-[0.25em] text-forest-800" data-testid="marco-regs-title">
              {t.marco.regsTitle}
            </h3>
            <div className="mt-5">
              {t.marco.regs.map((reg) => (
                <div key={reg.code} className="rule py-4" data-testid={`marco-reg-${reg.code.split(" ")[0].toLowerCase()}`}>
                  <p className="text-sm font-bold text-forest-800">{reg.code}</p>
                  <p className="mt-1 text-xs leading-relaxed text-forest-800/65">{reg.detail}</p>
                </div>
              ))}
              <div className="rule" aria-hidden="true" />
            </div>
          </Reveal>

          <div className="space-y-6 lg:col-span-3">
            <Reveal>
              <p className="text-base leading-relaxed text-forest-800 md:text-lg">{t.marco.p1}</p>
              <p className="mt-5 text-base leading-relaxed text-forest-800/80">{t.marco.p2}</p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="callout-orange p-6" data-testid="marco-callout">
                <h4 className="font-body text-[11px] font-bold uppercase tracking-[0.25em] text-ember">
                  {t.marco.calloutTitle}
                </h4>
                <p className="mt-3 text-sm leading-relaxed text-forest-800/85">{t.marco.calloutText}</p>
              </div>
            </Reveal>
            <Reveal delay={0.25}>
              <div className="border-t-2 border-forest-800 pt-6">
                <p className="font-display text-lg italic leading-relaxed text-forest-800 md:text-xl" data-testid="marco-quote">
                  “{t.marco.bottomQuote}”
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
